import React, { useState } from "react";
import { Button, Dialog, DialogActions, DialogContent, DialogTitle } from "@mui/material";
import { DataGrid, GridColDef, GridRowId, GridRowParams } from "@mui/x-data-grid";
import { title } from "process";



interface IProps {
    title: string;
    columns: GridColDef[];
    disabledBtn: boolean;
    currentArray: any[];
    selectedId: number[];
    setSelectedId: Function;
}


export const SelectTable:React.FC<IProps> = ({
    title, columns, disabledBtn, currentArray, selectedId,setSelectedId
}) => {
    const [isOpenAdd,setIsOpenAdd] = useState(false);
    //
    const [addNewPartner,setAddNewPartner] = useState<GridRowId[]>([]);
    const [isOpenEdit,setIsOpenEdit] = useState(false);

    const handleAddNew = () => {
        setAddNewPartner([]);
        setIsOpenAdd(true)
    }

    const handleAddBtn = () => {

        setSelectedId([...selectedId, ...addNewPartner]);
        setIsOpenAdd(false);

    }



    return(
        <>

            <Dialog open={isOpenAdd} onClose={() => setIsOpenAdd(false)} maxWidth="md" fullWidth>
                <DialogTitle>{title} zuordnen</DialogTitle>
                <DialogContent>
                    <DataGrid
                        sx={{mt: 2}}
                        autoHeight
                        checkboxSelection 
                        rows={currentArray}
                        onRowSelectionModelChange={(newRowSelectionModel) => {
                            setAddNewPartner([
                                ...newRowSelectionModel
                            ])                       
                        }}
                        rowSelectionModel={addNewPartner}
                        columns={columns}
                        //getRowId={(row) => row.idContact}
                        //isRowSelectable={(params: GridRowParams) => props.contactArray.map(x => x.idContact).indexOf(Number(params.row.idContact)) === -1 }
                        isRowSelectable={(params: GridRowParams) => selectedId.indexOf(Number(params.id)) === -1 }
                        initialState={{
                            pagination: {
                                paginationModel: {
                                    pageSize: 50,
                                },
                            },
                        }}
                    />
                </DialogContent>
                <DialogActions>
                    <Button variant="outlined" onClick={() => setIsOpenAdd(false)}>Abbruch</Button>
                    <Button variant="contained" onClick={handleAddBtn}>Hinzufügen</Button>
                </DialogActions>
            </Dialog>
            <Button disabled={disabledBtn} variant="outlined" sx={{float: "right"}} onClick={handleAddNew}>Zuordnen</Button>
        </>
    )

}